import { useAtom } from "jotai";
import { useCallback, useEffect, useState } from "react";

import { ArcadeGames } from "../../types";
import { retrieveFromSessionStorage, saveInSessionStorage } from "../../utils";
import { showIntroModalAtom } from "../arcade-intro-modal/arcade-intro-modal.state";

export function useArcadeInstructionsModal(
  currentGame: ArcadeGames
): [boolean, () => void] {
  const [showInstructionsModal, setShowInstructionsModal] = useState<boolean>(
    false
  );
  const [showIntroModal] = useAtom(showIntroModalAtom);

  const shouldShowInstructionsModal = useCallback(() => {
    const ARCADE_CURRENT_GAME = "arcadeCurrentGame";
    const arcadeCurrentGame = retrieveFromSessionStorage(ARCADE_CURRENT_GAME);

    if (!showIntroModal && arcadeCurrentGame !== currentGame) {
      saveInSessionStorage(ARCADE_CURRENT_GAME, currentGame);
      return true;
    }

    return false;
  }, [currentGame, showIntroModal]);

  const handleHideInstructionsModal = useCallback(() => {
    setShowInstructionsModal(false);
  }, []);

  useEffect(() => {
    setShowInstructionsModal(shouldShowInstructionsModal());
  }, [shouldShowInstructionsModal]);

  return [showInstructionsModal, handleHideInstructionsModal];
}
